<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">
        <div class="row">
          <div class="col-md-10 padding-left-0px">
            <label class="margin-bottom-0px color-Assign font-weight-bold">Edit</label>
          </div>
          <div class="col-md-2 float-right">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.close('Close click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Current Long Value :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{LongValue}}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Current Short Value :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{ShortValue}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        <div class="">
          <form class="form" novalidate="" #f="ngForm">
            <div class="card">
              <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                <div class="row">
                  <div class="col-md-12 padding-l-0px">
                    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
                      <div class="card-body card-body-general padding-top-0px">
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right">
                                <label for="diaplayName" class="margin-bottom-0px margin-top-5px">New Long Value</label>
                              </div>

                              <div class="col-md-5">
                                <input type="text" class="form-control" placeholder="Long Value"
                                       id="UpdatedLongValue"
                                       [(ngModel)]="UpdatedLongValue"
                                       name="UpdatedLongValue" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                       maxlength="30" required #UpdLongValue="ngModel">

                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right">
                                <label for="diaplayName" class="margin-bottom-0px margin-top-5px">New Short Value</label>
                              </div>

                              <div class="col-md-5">
                                <input type="text" class="form-control" placeholder="Short Value"
                                       id="UpdatedShortValue"
                                       [(ngModel)]="UpdatedShortValue"
                                       name="UpdatedShortValue" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                       maxlength="30" required #UpdShortValue="ngModel">

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="card-footer">
                <button type="submit" (click)="SaveCodeTypeValue()"
                        class="btn actions-btn-prime float-right font-size-13px">Save</button>
                <button type="button"
                        class="btn btn-secondary btn-raised margin-right-15px float-right button-Schedule actions-btn-prime actions-btn-prime3 font-size-13px"
                        (click)="activeModal.close('Close click')">Cancel</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
